import { Link } from 'react-router-dom';
import ChatDock from './ChatDock';
import Footer from './Footer';
import Header from './Header';
import Ornament from './Ornament';

export default function Layout({ children }) {
  return (
    <div className="page">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Header />
      <main id="main">{children}</main>
      <Footer />
      <ChatDock />
    </div>
  );
}

export function PageHero({ eyebrow, title, lead, crumbs = [] }) {
  return (
    <section className="page-hero">
      <div className="container">
        <nav className="crumbs" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          {crumbs.map((crumb) => (
            <span key={crumb.label}>
              <span aria-hidden="true"> / </span>
              {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : <span aria-current="page">{crumb.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        <Ornament />
        {lead ? <p className="page-hero__lead">{lead}</p> : null}
      </div>
    </section>
  );
}
